import { Link as RouterLink } from 'react-router-dom';
// material-ui
import Link from '@mui/material/Link';
// project imports
import { DASHBOARD_PATH } from 'config';
import FairplayLogo from 'assets/images/fairplay-logo.png';
import ArionPlayLogoMobile from 'assets/images/ArionPlayLogoMobile.png';
import XoPlayLogoMobile from 'assets/images/xoplay-mobile-logo.png';
import LuckyPlayLogoMobile from 'assets/images/lucky-play-mobile.png';
import PeryaPlayLogoMobile from 'assets/images/northalley-mobile-logo.png';
const DOMAIN = import.meta.env.VITE_APP_HOME_PAGE;
const THEME = import.meta.env.VITE_APP_USE_THEME;

// ==============================|| MAIN LOGO ||============================== //

const LogoSectionMobile = () => (
    <Link
        component={RouterLink}
        to={DASHBOARD_PATH}
        aria-label="theme-logo"
        className=""
        sx={{ alignItems: 'center', display: 'flex', position: 'relative', top: '0px' }}
    >
        {/* <Logo /> */}
        {/* <img src={RoyalarionLogoMobile} alt="Alibaba" width="40px" /> */}
        {THEME === 'xoplay' && <img src={XoPlayLogoMobile} alt="XOPlay" width="60px" />}
        {THEME === 'fairplay' && <img src={FairplayLogo} alt="Alibaba" width="40px" />}
        {THEME === 'arionplay' && <img src={ArionPlayLogoMobile} alt="Alibaba" width="20px" />}
        {THEME === 'luckyplay' && <img src={LuckyPlayLogoMobile} alt="Alibaba" width="34px" />}
        {THEME === 'peryaplay' && <img src={PeryaPlayLogoMobile} alt="Alibaba" width="100px" />}
        {THEME === 'lbtsommt' && <img src={PeryaPlayLogoMobile} alt="LBTSOMMT" width="100px" />}
    </Link>
);

export default LogoSectionMobile;
